import { Button, Container, Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import BaseModal from './BaseModal'
import { useEffect, useState } from 'react'
import { mediaQueryPoint, useMediaQuery } from 'utils/hooks'
import ContentModalHelp from './component/ContentModalHelp'
import ContentModalHelpMobile from './component/ContentModalHelpMobile'

import imgB1vMobile from 'assets/images/imgplay/g1.png'
import imgB2vMobile from 'assets/images/imgplay/g2.png'
import imgB1cMobile from 'assets/images/imgplay/m1.png'
import imgB2cMobile from 'assets/images/imgplay/m2.png'
import imgB1kMobile from 'assets/images/imgplay/k1.png'
import imgB2kMobile from 'assets/images/imgplay/k2.png'
import imgB3Mobile from 'assets/images/imgplay/b3.png'
import imgB4Mobile from 'assets/images/imgplay/b4.png'
import imgB5Mobile from 'assets/images/imgplay/b5.png'
import imgB6Mobile from 'assets/images/imgplay/b6.png'

function ModalHelpPlay({ show, onHide, idGame, ...otherProps }) {
	const { t } = useTranslation()
	const [stateModal, setStateModal] = useState({
		title: '',
		help: [],
	})
	const isMobileMD = useMediaQuery(`(max-width: ${mediaQueryPoint.md}px)`)
	const minerGold = {
		title: 'Miner gold',
		help: [
			{
				img: imgB1vMobile,
				text: 'ເລືອກເກມທີ່ຕ້ອງການຫຼິ້ນ(Minnergold)',
			},
			{
				img: imgB2vMobile,
				text: 'ເຂົ້າໜ້າListroom, ກົດCreateRoom ເພື່ອສ້າງຫ້ອງຫຼິ້ນເກມ',
			},
			{
				img: imgB3Mobile,
				text: 'ໃສ່ຈຳນວນgoldທີ່ທ່ານຕ້ອງການພະນັນແລະclickAgree ເພື່ອເຫັນດີທີ່ຈະສ້າງຫ້ອງ(ໝາຍເຫດຄຳທີ່ຈະພະນັນຕໍ່າສຸດແມ່ນ100ຄຳແລະສູງສຸດ2000ຄຳ',
			},
			{
				img: imgB4Mobile,
				text: 'ສໍາລັບເຈົ້າຂອງຫ້ອງ: ລໍຖ້າຜູ້ຫຼິ້ນອື່ນເຂົ້າຮ່ວມຫ້ອງເກມ',
			},
			{
				img: imgB5Mobile,
				text: 'ສໍາລັບຜູ້ຫຼິ້ນທີ່ບໍ່ໄດ້ເປັນເຈົ້າຂອງຫ້ອງ: ເລືອກຫ້ອງທີ່ສ້າງແລ້ວເຂົ້າຮ່ວມມັນ',
			},
			{
				img: imgB6Mobile,
				text: 'ຫຼັງຈາກຜູ້ນແມ່ນກຽມພ້ອມ,ກົດປຸ່ມ Start ເພື່ອເລີ່ມຕົ້ນການຫຼິ້ນເກມ',
			},
		],
	}
	const beatMouse = {
		title: 'Beat mouse',
		help: [
			{
				img: imgB1cMobile,
				text: 'ເລືອກເກມທີ່ຕ້ອງການຫຼິ້ນ(Beat mouse)',
			},
			{
				img: imgB2cMobile,
				text: 'ເຂົ້າໜ້າListroom, ກົດCreateRoom ເພື່ອສ້າງຫ້ອງຫຼິ້ນເກມ',
			},
			{
				img: imgB3Mobile,
				text: 'ໃສ່ຈຳນວນgoldທີ່ທ່ານຕ້ອງການພະນັນແລະclickAgree ເພື່ອເຫັນດີທີ່ຈະສ້າງຫ້ອງ(ໝາຍເຫດຄຳທີ່ຈະພະນັນຕໍ່າສຸດແມ່ນ100ຄຳແລະສູງສຸດ2000ຄຳ',
			},
			{
				img: imgB4Mobile,
				text: ' ສໍາລັບເຈົ້າຂອງຫ້ອງ: ລໍຖ້າຜູ້ຫຼິ້ນອື່ນເຂົ້າຮ່ວມຫ້ອງເກມ',
			},
			{
				img: imgB5Mobile,
				text: 'ສໍາລັບຜູ້ຫຼິ້ນທີ່ບໍ່ໄດ້ເປັນເຈົ້າຂອງຫ້ອງ: ເລືອກຫ້ອງທີ່ສ້າງແລ້ວເຂົ້າຮ່ວມມັນ.',
			},
			{
				img: imgB6Mobile,
				text: 'ຫຼັງຈາກຜູ້ນແມ່ນກຽມພ້ອມ,ກົດປຸ່ມ Start ເພື່ອເລີ່ມຕົ້ນການຫຼິ້ນເກມ',
			},
		],
	}
	const knifeHit = {
		title: 'Knife hit',
		help: [
			{
				img: imgB1kMobile,
				text: 'ເລືອກເກມທີ່ຕ້ອງການຫຼິ້ນ(Knife Hit)',
			},
			{
				img: imgB2kMobile,
				text: 'ເຂົ້າໜ້າListroom, ກົດCreateRoom ເພື່ອສ້າງຫ້ອງຫຼິ້ນເກມ',
			},
			{
				img: imgB3Mobile,
				text: 'ໃສ່ຈຳນວນgoldທີ່ທ່ານຕ້ອງການພະນັນແລະclickAgree ເພື່ອເຫັນດີທີ່ຈະສ້າງຫ້ອງ(ໝາຍເຫດຄຳທີ່ຈະພະນັນຕໍ່າສຸດແມ່ນ100ຄຳແລະສູງສຸດ2000ຄຳ',
			},
			{
				img: imgB4Mobile,
				text: ' ສໍາລັບເຈົ້າຂອງຫ້ອງ: ລໍຖ້າຜູ້ຫຼິ້ນອື່ນເຂົ້າຮ່ວມຫ້ອງເກມ',
			},
			{
				img: imgB5Mobile,
				text: 'ສໍາລັບຜູ້ຫຼິ້ນທີ່ບໍ່ໄດ້ເປັນເຈົ້າຂອງຫ້ອງ: ເລືອກຫ້ອງທີ່ສ້າງແລ້ວເຂົ້າຮ່ວມມັນ.',
			},
			{
				img: imgB6Mobile,
				text: 'ຫຼັງຈາກຜູ້ນແມ່ນກຽມພ້ອມ,ກົດປຸ່ມ Start ເພື່ອເລີ່ມຕົ້ນການຫຼິ້ນເກມ',
			},
		],
	}
	useEffect(() => {
		if (idGame === 1) {
			setStateModal(minerGold)
		}
		if (idGame === 2) {
			setStateModal(knifeHit)
		}
		if (idGame === 3) {
			setStateModal(beatMouse)
		}
	}, [idGame])
	return (
		<BaseModal show={show} onHide={onHide} hideDecor={true} {...otherProps}>
			<Container className="baseinput-container" fluid>
				<Modal.Header>{stateModal.title}</Modal.Header>
				<Modal.Body>
					{isMobileMD ? (
						<ContentModalHelpMobile data={stateModal.help} />
					) : (
						<ContentModalHelp data={stateModal.help} />
					)}
				</Modal.Body>
			</Container>
		</BaseModal>
	)
}

export default ModalHelpPlay
